import {useContext} from 'react';
import {AdminAccessContext} from 'packages/common/contexts/admin-access-context/AdminAccessContext';

export const useAdminAccess = () => {
  const context = useContext(AdminAccessContext);

  // Si le context n'est pas disponible, retourner un état par défaut
  // Cela permet au RoleBasedGuard de fonctionner même sans AdminAccessProvider
  if (!context) {
    return {
      isAdminAccessMode: false,
      targetCompany: null,
      remainingTime: null,
      reason: null,
      grantAccess: async () => ({success: false, error: 'Provider not available'}),
      revokeAccess: async () => ({success: false, error: 'Provider not available'}),
      checkStatus: async () => {},
    };
  }

  return context;
};
